import React from "react";
import AppRouter from "./routes/AppRouter";
import { QuizProvider } from "./context/QuizContext";
import { AuthProvider } from "./context/AuthContext";
import { useLocaleMonitor } from "./hooks/useLocaleMonitor";
import "./styles/font-tf-komodo-24.scss";

function App() {
  // Monitor locale changes (important for QA where header/footer sets cookies after load)
  const currentLocale = useLocaleMonitor();
  
  // Pricing library initialization removed; Magellan API is used directly for pricing.
  // Post-login state restoration is now handled in AppRouter.jsx (inside Router context)

  return (
    <div id="tfapp" className="App" data-locale={currentLocale}>
      <AuthProvider>
        <QuizProvider>
          <AppRouter />
        </QuizProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
